export default "__VITE_ASSET__Dr89LQEv__"